export default __webpack_public_path__ + "static/media/conquistar.4b8c9317.svg";